module.exports = __webpack_public_path__ + "media/Audio15_e.1d663638.wav";